import React, {Dispatch, SetStateAction} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import DocusealTemplate from '../components/DocusealTemplate'
import Skeleton from 'react-loading-skeleton'
import { ToolTipUIForModal } from '../../widgets/components/UI/ToolTipUIForModal'
import { useThemeMode } from '../../../../_metronic/partials'

const TemplateView = ({
  showViewTemlateModal,
  setShowViewTemplateModal,
  token,
  templateName,
  viewTemplateLoading,
}: {
  showViewTemlateModal: boolean
  setShowViewTemplateModal: Dispatch<SetStateAction<boolean>>
  token: string | undefined
  templateName: string
  viewTemplateLoading: boolean
}) => {
  const {mode} = useThemeMode()
  return (
    <Modal
      show={showViewTemlateModal}
      size='xl'
      onHide={() => {
        setShowViewTemplateModal(false)
      }}
      aria-labelledby='contained-modal-title-vcenter'
      centered
      className='template-modal-container'
    >
      <Modal.Header>
        <div className='w-100 d-flex justify-content-between align-items-center'>
          <div className='d-flex'>
            <div
              className='d-flex align-items-center cursor-pointer'
              onClick={() => setShowViewTemplateModal(false)}
            >
              <KTSVG path={mode === 'dark' ? toAbsoluteUrl('/media/icons/digital-signing/ic_close_dark.svg') : toAbsoluteUrl('/media/icons/digital-signing/ic_close.svg')} />
            </div>
            <div className='ps-4 font-size-20 fw-bold'>{templateName}</div>
          </div>
          <ToolTipUIForModal tooltipText='View document template for digital sharing' />
        </div>
      </Modal.Header>
      <Modal.Body>
        {viewTemplateLoading ? (
          <div className='d-flex justify-content-center mt-5'>
            <Skeleton
              width='80vw'
              height={600}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          </div>
        ) : (
          <DocusealTemplate token={token} isView={true} />
        )}
      </Modal.Body>
    </Modal>
  )
}

export default TemplateView
